import React, { Fragment, PureComponent, useState, useEffect, useContext, useReducer, useMemo, useCallback } from 'react';
import { connect, Provider } from 'react-redux';
import moment from 'moment';
import { merge, get, clone, set } from 'lodash';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { withRouter, useHistory, useParams, useLocation, useRouteMatch } from 'react-router';
import { useDispatch, useMappedState, StoreContext } from 'redux-react-hook';
import { Button, List, Modal, Icon, Switch, InputItem, Toast } from 'antd-mobile';
import { Loading } from '../../../components/loading';
import { uploadImg, setHomepageStatus } from '../../commonAction';
import { VBottomNav } from '../../../components/copyright/common';
import { readCookie, formatImgWH, isVideoUrl } from '../../../utils/common';
import { DetailShare } from '../../../components/copyright/detailShare';
import { TextDialog } from '../../../components/textDialog';
import { getWeixinConfig, configWeixin } from '../../../utils/weixin';
import { getUploadHistory, getUserInfo } from './action';
// import Tloader from 'react-touch-loader';
import Tloader from '../../../components/loader';
import LazyLoad from 'vanilla-lazyload';
import { Camera } from '../../../components/icons/camera';
import { ShareButton } from '../../../components/icons/shareButton';
import { Contract } from '../../../components/icons/contract';
import { Checked } from '../../../components/icons/checked';
import { Vh5Video } from '../../../components/videoPaler';
import { _track } from '../../../utils/track';
import { PlayButton } from '../../../components/icons/playButton';
import './index.scss';
const mapStateToProps = state => {
	return {
		uploadHistoryList: state.CopyrightUcenterReducers.uploadHistoryList,
		totalCount: state.CopyrightUcenterReducers.totalCount,
		pageIndex: state.CopyrightUcenterReducers.pageIndex,
		pageSize: state.CopyrightUcenterReducers.pageSize,
		baseInfo: state.CopyrightBaseinfoReducers.baseinfo
	};
};
function formatZ(s) {
	return ('0' + s).slice(-2);
}
function itemStatusTip(status) {
	if (status === 10) {
		return '待审核';
	} else if (status === 20) {
		return '已发布';
	} else if (status === 30) {
		return '已驳回';
	}
}
function Organization(props) {
	return (
		<div className="organization">
			<Checked />
			<span>{props.name}</span>
		</div>
	);
}
function Photographer(props) {
	return (
		<div className="photographer">
			<Camera />
			<span>摄影师</span>
		</div>
	);
}
function ContractPhotographer(props) {
	return (
		<div className="photographer">
			<Contract />
			<span>认证摄影师</span>
		</div>
	);
}
function handleClickVideo(item) {
	console.log('视频 ', item);
}
function Images(props) {
	let { toIdeital } = props;
	function showRejectedReason(item) {
		if (item.status !== 30) {
			return;
		}
		props.showRejectedReason(item);
	}
	let items = props.items;
	console.log('items...', items);
	return items.map(item => {
		return (
			<li key={items.length === 1 ? item.key : item.thumbKey}>
				{item.declineType !== 3 ? <img className="lazy" alt="" src={item.thumbKey} /> : ''}
				{item.type === 2 && item.declineType !== 3 ? (
					<PlayButton
						size="36"
						duration={item.duration}
						onClick={() => {
							toIdeital(item);
						}}
					/>
				) : (
					''
				)}
				<span
					className="status"
					onClick={() => {
						showRejectedReason(item);
					}}>
					{item.status === 30 ? <i className="iconfont rejected-question">&#xe669;</i> : ''}
					<span className="reject-text">{itemStatusTip(item.status)}</span>
					{item.status === 30 ? <i className="iconfont rejected-arrow">&#xe655;</i> : ''}
				</span>
			</li>
		);
	});
}
let lazyLoadInstance = null;
function displayedTime(item) {
	let d = new Date(item.submitTime);
	let hour = String(d.getHours());
	let minute = String(d.getMinutes());
	let second = String(d.getSeconds());
	if (hour.length === 1) {
		hour = '0' + hour;
	}
	if (minute.length === 1) {
		minute = '0' + minute;
	}
	if (second.length === 1) {
		second = '0' + second;
	}
	return d.getFullYear() + '.' + (d.getMonth() + 1) + '.' + d.getDate() + ' ' + hour + ':' + minute + ':' + second;
}
function HeaderImageList(props) {
	let { toIdeital } = props;
	let list = props.list.map((item, index) => {
		let { width, height, contentResponseList } = item;
		console.log('item', item);
		// debugger;
		let formatWh = formatImgWH({ boxWidth: 600 / 75, boxHeight: 372 / 75, actualWdith: width / 75, actualHeight: height / 75 });
		return (
			<li key={'heaerimage-' + item.id + '-' + index} className="date-item">
				<h3>
					{/* {moment(item.addTime).format('YYYY-MM-DD')} */}
					{displayedTime(item)}
					<span className="dot"></span>
					<div className="label">
						{item.isOriginal === 20 ? (
							<span className="original">
								<span className="iconfont">&#xe660;</span>
								<span>原创</span>
							</span>
						) : (
							''
						)}
					</div>
					{/* <div
						className="share-button"
						onClick={() => {
							props.showShareFn(item);
						}}>
						<i className="iconfont rejected-question">&#xe657;</i>
						<span>分享</span>
					</div> */}
					<ShareButton
						onClick={() => {
							props.showShareFn(item);
						}}
					/>
				</h3>
				<h4>{item.contentResponseList[0].sectionDescription}</h4>
				{/* <ul className="images single">
					{
						contentResponseList.map(item=>{
							return (
								<li key={item.thumbKey}>
									<img className="lazy" alt="" data-src={item.thumbKey} style={{ width: formatWh.width + 'rem', height: formatWh.height + 'rem' }} />
								</li>
							);
						});
					}
					<div className="clear"></div>
				</ul> */}
				<ul className={contentResponseList.length === 1 ? 'images single' : 'images'}>
					<Images items={contentResponseList} showRejectedReason={props.showRejectedReason} toIdeital={toIdeital} />
					<div className="clear"></div>
				</ul>
				<h4 className="subject">
					<span className="iconfont topic"></span>
					{item.section}
				</h4>
			</li>
		);
	});
	return <ul>{list}</ul>;
}
function CopyrightUcenter() {
	let history = useHistory();
	let userId = readCookie('copyrightuserId');
	if (!userId || userId === 'null') {
		// 未登录直接进入ucenter
		// userId = '18825'
		window.location.href = '/vpmobile/copyright/home/';
	}
	let copyright_nickname = readCookie('copyright_nickname');
	let copyright_iscontract = readCookie('copyright_iscontract') === 'true';
	let copyright_isphotographer = readCookie('copyright_isphotographer');
	let copyright_instName = readCookie('copyright_instName');
	let copyright_firstUpdate = readCookie('copyright_firstUpdate') === 'true';
	let copyright_showState = readCookie('copyright_showState');
	const mapState = useCallback(mapStateToProps, []);
	const { uploadHistoryList, totalCount, pageIndex, pageSize, baseInfo = {} } = useMappedState(mapState);
	let { avatar } = baseInfo;
	let dispatch = useDispatch();
	const [pageData, setPageData] = useState({
		isShowRejectedReason: false,
		rejectReason: '',
		isShowShare: false,
		sharedData: {}
	});
	let [playerOptions, setPlayerOptions] = useState({});
	function showRejectedReason(item) {
		pageData.isShowRejectedReason = true;
		pageData.rejectReason = item.auditComment;
		setPageData({ ...pageData });
	}
	function closeRejectedReason() {
		pageData.isShowRejectedReason = false;
		setPageData({ ...pageData });
	}
	function showShare(item) {
		let isVideo = isVideoUrl(item.contentResponseList[0].key);
		let list = item.contentResponseList.slice(0);
		if (isVideo) {
			list.forEach(item => {
				item.key = item.thumbKey;
			});
		} else {
			list.forEach(item => {
				item.key = item.originalUrl || item.key;
			});
		}
		let shareData = {
			fromAvatar: avatar,
			fromName: copyright_nickname,
			topicName: item.section,
			title: item.description,
			sectionId: item.sectionId,
			list
		};
		pageData.sharedData = shareData;
		pageData.isShowShare = true;
		setPageData({ ...pageData });
		console.log('showShare', shareData);
	}
	function closeShare() {
		pageData.isShowShare = false;
		setPageData({ ...pageData });
	}
	function goPraise() {
		window.location.href = '/vpmobile/copyright/praise/';
	}
	let [effectFlag, setEffectFlag] = useState(1);
	let handleLoadMore = resolve => {
		if (pageIndex * pageSize >= totalCount) {
			return;
		}
		dispatch(
			getUploadHistory(
				{
					index: pageIndex + 1,
					limit: pageSize,
					sort: -1,
					userId
				},
				data => {
					_track({
						trackName: 'toutu_ucenter_page',
						payload: {
							userId,
							page_action_name: 'ucenter-histoury-list',
							index: pageIndex + 1,
							limit: pageSize,
							sort: -1
						}
					});
					lazyLoadInstance.update();
					resolve();
				},
				data => {
					_track({
						trackName: 'toutu_ucenter_page',
						payload: {
							userId,
							...data,
							page_action_name: 'ucenter-histoury-list',
							index: pageIndex + 1,
							limit: pageSize,
							sort: -1
						}
					});
				}
			)
		);
	};
	function onPlayer({ url, type }) {
		const videoJsOptions = {
			autoplay: true,
			controls: true,
			fluid: true,
			controlBar: {
				fullscreenToggle: false
			},
			sources: [
				{
					src: url,
					type: type || 'video/mp4'
				}
			],
			closeCallback: () => {
				setPlayerOptions({});
			}
		};
		setPlayerOptions(videoJsOptions);
	}
	function toIdeital(item) {
		console.log('video', item);
		if (item.type === 2) {
			onPlayer({
				url: item.thumbVideoUrl,
				type: ''
			});
			return;
		}
	}
	function toEditor() {
		_track({
			trackName: 'toutu_ucenter_page',
			payload: {
				PCenter_Action: '作品署名提醒'
			}
		});
		history.push({ pathname: '/vpmobile/copyright/editor' });
	}
	let handleRefresh = (resove, reject) => {
		console.log('重新上拉加载刷新逻辑');
		//resove();
	};
	useEffect(() => {
		if (effectFlag === 1) {
			setEffectFlag(2);
			dispatch(
				getUploadHistory(
					{ index: 1, limit: 10, sort: -1, userId },
					data => {
						lazyLoadInstance.update();
						_track({
							trackName: 'toutu_ucenter_page',
							payload: {
								userId,
								page_action_name: 'ucenter-histoury-list',
								index: 1,
								limit: 10,
								sort: -1
							}
						});
					},
					data => {
						_track({
							trackName: 'toutu_ucenter_page',
							payload: {
								userId,
								...data,
								page_action_name: 'ucenter-histoury-list',
								index: 1,
								limit: 10,
								sort: -1
							}
						});
					}
				)
			);
		}
		dispatch(
			getWeixinConfig({ url: window.location.href }, data => {
				console.log('getWeixinConfig', data);
				configWeixin(data, {
					title: '投图',
					desc: '主题影像即时创作平台',
					toPage: 'home'
				});
				_track({
					trackName: 'toutu_ucenter_page',
					payload: {
						...data,
						page_action_name: 'ucenter-init-wxconfig'
					}
				});
			})
		);
	}, [dispatch, effectFlag, userId]);
	useEffect(() => {
		lazyLoadInstance = new LazyLoad({
			elements_selector: '.lazy',
			load_delay: 200,
			data_bg: 'lazy-bg'
			// ... more custom settings?
		});
	}, [dispatch]);

	return (
		<div className="copyright copyright-ucenter">
			<Tloader initializing={0} onRefresh={handleRefresh} hasMore={true} onLoadMore={handleLoadMore} className="tloader some class">
				<header className="header">
					{/* <i
						className="setting"
						onClick={() => {
							history.push({ pathname: '/vpmobile/copyright/setting' });
						}}>
						设置
					</i> */}
					<i
						className="iconfont setting"
						onClick={() => {
							_track({
								trackName: 'toutu_ucenter_page',
								payload: {
									page_action_name: 'ucenter-pushpathname-setting',
									PCenter_Action: '设置'
								}
							});
							history.push({ pathname: '/vpmobile/copyright/setting' });
						}}>
						&#xe658;
					</i>
				</header>
				<section className="content">
					<div className="personal-info">
						<i className="avatar" style={{ backgroundImage: `url('${avatar || 'https://gallerytemplate.vphotos.cn/copyright/default-avatar.jpg'}` }}></i>
						<div className="info">
							<p className="name">{copyright_nickname || '用户_000000'}</p>

							<div className="title-wrapper">
								{copyright_instName ? <Organization name={copyright_instName} /> : ''}
								{copyright_iscontract ? <ContractPhotographer /> : <Photographer />}
							</div>
						</div>
					</div>
					{copyright_firstUpdate ? (
						<div className="updateTip" onClick={toEditor}>
							<span className="iconfont">&#xe654;</span>
							<span>建议使用真实姓名给作品署名，请尽快修改。</span>
							<span className="iconfont">&#xe655;</span>
						</div>
					) : (
						''
					)}
					<div className="header-image">
						<h2>
							上传记录<span>{totalCount}</span>
						</h2>
						<h2 className="praise-entry" onClick={goPraise}>
							我的点赞
						</h2>
						<div className="axis"></div>
						<HeaderImageList list={uploadHistoryList} showRejectedReason={showRejectedReason} showShareFn={showShare} toIdeital={toIdeital} />
						{pageIndex * pageSize < totalCount ? <Loading /> : <div className="text">我是底线，不能更低了</div>}
					</div>
				</section>
			</Tloader>
			<VBottomNav activeName="ucenter" />
			{pageData.isShowRejectedReason ? <TextDialog title="驳回原因" footer="关闭" clickFooter={closeRejectedReason} text={pageData.rejectReason} /> : ''}
			{pageData.isShowShare ? <DetailShare data={pageData.sharedData} onClose={closeShare} from="ucenter" /> : ''}
			{playerOptions && playerOptions.sources ? <Vh5Video {...playerOptions} /> : ''}
		</div>
	);
}
export { CopyrightUcenter };
